import { $apiV1 } from "../../../config/api";

// Maximum number of events we are willing to render/search at once. When a client selects a
// huge number of matches an on-ball parameter can resolve to tens of thousands of events, which
// makes the heavy markers_search request slow and the pitch unresponsive.
export const EVENTS_RESULT_LIMIT = 1000;

// Fast pre-check that hits a lightweight backend route returning ONLY the count the eventual
// markers_search would produce (no mirroring, no relation graph, no serialization). We call this
// on every selection change and only fire the expensive search when the count is within the limit.
export async function fetchEventsResultCount(payload) {
  const result = await $apiV1.post("/stats/markers_count", payload);
  return Number(result?.data?.count ?? 0);
}

// User-facing message shown when a selection exceeds the limit.
export function buildEventsResultLimitMessage(count) {
  return `There are ${count} results. Please select fewer matches so the result stays under ${EVENTS_RESULT_LIMIT}.`;
}
